import { HStack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { sumMaxScore } from "@/scoringUi";

/**
 * Live "Model oceny rekrutacji: X / 100 pkt" display (spec 2 §6). Sums
 * maxScore across every scoring-capable criterion currently wired into the
 * recruitment form (see LOCAL_CRITERION_NAMES in jobOfferMapper.js) plus,
 * when available, the criteria inherited from the recruitment's scenario.
 *
 * @param {object} props
 * @param {Array<{scoring: object}>} props.localCriteria - the form's own scoring-capable sections, e.g. [{scoring: jobOffer.availability.scoring}]
 * @param {number} [props.scenarioMaxScore] - sum of scoring-enabled scenario criteria, if resolved (see GET /api/recruitment/{id}/scoring-model)
 * @param {number} [props.target=100] - the recommended total (spec 1 §6)
 */
const ScoringModelSummary = ({ localCriteria, scenarioMaxScore = 0, target = 100 }) => {
    const { t } = useTranslation("jobOffer");
    const recruitmentMaxScore = sumMaxScore(localCriteria);
    const total = recruitmentMaxScore + scenarioMaxScore;

    if (total === 0) return null;

    return (
        <HStack
            w="full"
            px={4}
            py={3}
            borderRadius={8}
            border="1px solid"
            borderColor={total === target ? "green.200" : "orange.200"}
            bg={total === target ? "green.50" : "orange.50"}
            justify="space-between"
            flexWrap="wrap"
            gap={2}
        >
            <Text fontSize="sm" fontWeight={600} color="gray.900">
                {t("step5.scoring.title", "Model oceny rekrutacji")}: {total} / {target} pkt
            </Text>
            <Text fontSize="xs" color="gray.600">
                {scenarioMaxScore} pkt ze scenariusza, {recruitmentMaxScore} pkt z ustawień tej rekrutacji
            </Text>
            {total !== target && (
                <Text fontSize="xs" color="orange.600" w="full">
                    Model oceny ma obecnie {total} / {target} pkt. Uzupełnij lub skoryguj kryteria przed publikacją.
                </Text>
            )}
        </HStack>
    );
};

export default ScoringModelSummary;
